var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirport01 = function SvgAirport01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "airport-01_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#airport-01_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.87 3.703a3.789 3.789 0 0 0-1.39 3.054l.103 2.659-5.217 2.042a.89.89 0 0 0-.566.823V13.5l5.92-1.012.188 4.838-1.82 1.15a.396.396 0 0 0-.188.343v1.081l3.26-.823 3.261.823v-1.081a.396.396 0 0 0-.188-.343l-1.82-1.15.189-4.838 5.92 1.012v-1.218a.89.89 0 0 0-.567-.823l-5.233-2.042.103-2.66a3.725 3.725 0 0 0-1.373-3.053.466.466 0 0 0-.583 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "airport-01_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgAirport01 as ReactComponent };